var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.835 11.782L17.835 4.282C17.7649 4.19416 17.6759 4.12321 17.5746 4.0744C17.4733 4.02559 17.3624 4.00016 17.25 4H6.75C6.63753 3.99983 6.52649 4.02512 6.42518 4.07395C6.32387 4.12279 6.23492 4.19391 6.165 4.282L0.165 11.782C0.0584898 11.9148 0.000303216 12.0798 0 12.25L0 19C0 19.3978 0.158035 19.7794 0.43934 20.0607C0.720644 20.342 1.10218 20.5 1.5 20.5H22.5C22.8978 20.5 23.2794 20.342 23.5607 20.0607C23.842 19.7794 24 19.3978 24 19V12.25C24.0001 12.0797 23.9418 11.9146 23.835 11.782ZM22.5 13H17.25L14.25 16H9.75L6.75 13H1.5V12.5125L7.11 5.5H16.8885L22.4985 12.5125V13H22.5Z",
    fill: "#0973F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.835 4.282L23.835 11.782C23.9418 11.9146 24 12.25 24 12.25L22.4985 13V12.5125L16.8885 5.5H7.11L1.5 12.5125V13L0 12.25C0.000303216 12.0798 0.0584898 11.9148 0.165 11.782L6.165 4.282C6.23492 4.19391 6.32387 4.12279 6.42518 4.07395C6.52649 4.02512 6.63753 3.99983 6.75 4H17.25C17.3624 4.00016 17.4733 4.02559 17.5746 4.0744C17.6759 4.12321 17.7649 4.19416 17.835 4.282Z",
    fill: "#00AEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.db89b85a.svg";
export { ForwardRef as ReactComponent };